export const GET_LIST_PROHIBITED_ITEMS = "GET_LIST_PROHIBITED_ITEMS";
export const GET_LIST_PROHIBITED_ITEMS_SUCCESS = "GET_LIST_PROHIBITED_ITEMS_SUCCESS";
export const GET_LIST_PROHIBITED_ITEMS_FAILS = "GET_LIST_PROHIBITED_ITEMS_FAILS";
export const CHECK_COOKIES_LAST_UPDATE_ITEM_PROHIBITED = "CHECK_COOKIES_LAST_UPDATE_ITEM_PROHIBITED";
export const CHECK_COOKIES_DISPLAY_CONTENT_WARNING = "CHECK_COOKIES_DISPLAY_CONTENT_WARNING"
export const ON_CHANGE_DISPLAY_NEW_UPDATE_PROHIBITED = "ON_CHANGE_DISPLAY_NEW_UPDATE_PROHIBITED"
export const ON_CHANGE_DISPLAY_CONTENT_WARNING = "ON_CHANGE_DISPLAY_CONTENT_WARNING"


export const checkCookiesDisplayContentWarning = (payload) => {
    return {
        type: CHECK_COOKIES_DISPLAY_CONTENT_WARNING,
        payload
    }
}
export const onChangeDisplayContentWarning = (payload) => {
    return {
        type: ON_CHANGE_DISPLAY_CONTENT_WARNING,
        payload
    }
}
export const getListProhibitedItems = (payload) => {
    return {
        type: GET_LIST_PROHIBITED_ITEMS,
        payload
    }
}

export const getListProhibitedItemsSuccess = payload => {
    return {
        type: GET_LIST_PROHIBITED_ITEMS_SUCCESS,
        payload
    }
}

export const getListProhibitedItemsFails = payload => {
    return {
        type: GET_LIST_PROHIBITED_ITEMS_FAILS,
        payload
    }
}

export const checkCookiesLastUpdateProhibited = payload => {
    return {
        type: CHECK_COOKIES_LAST_UPDATE_ITEM_PROHIBITED,
        payload
    }
}

export const onChangeDisplayNewUpdateProhibited = payload => {
    return {
        type: ON_CHANGE_DISPLAY_NEW_UPDATE_PROHIBITED,
        payload
    }
}


// WEBPACK FOOTER //
// ./src/actions/prohibitedItems.js